import styled from 'styled-components';
import { motion } from 'framer-motion6';
import { sizes } from 'style';

export const MissionWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;

  @media ${sizes.tabletLandscape} {
    flex-direction: row;
  }
`;

export const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 20px;
  margin-top: 6px;

  @media ${sizes.tabletLandscape} {
    margin-left: auto;
    padding-bottom: 0px;
    height: 100%;
    width: 50%;

    @media (max-height: 710px) {
      margin-top: 60px;
    }
  }
`;

export const Heading = styled(motion.h1)`
  font-family: 'Times New Roman', Times, serif;
  font-weight: 400;
  font-size: 36px;
  letter-spacing: -1px;
  max-width: 545px;

  @media ${sizes.mobileLarge} {
    font-size: 50px;
  }

  @media ${sizes.desktop} {
    font-size: 60px;
  }

  @media ${sizes.largeDesktop} {
    font-size: 70px;
  }
`;

export const Section = styled(motion.div)``;

export const MissionText = styled(motion.p)`
  margin-top: 26px;
  margin-bottom: 0;
  max-width: 515px;
  line-height: 24px;
`;

export const SpotifyPlayer = styled(motion.iframe)`
  margin-top: 30px;
  width: 100%;
  max-width: 420px;
  height: 100px;
  border-radius: 12px;
  background-color: #22289a;

  @media (min-height: 700px) {
    height: 152px;
  }
`;

export const OpenRolesButton = styled(motion.button)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin-top: 30px;
  border: 0;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.turquoise};
  font-size: 16px;
  border-radius: 12px;
  padding: 11px 40px;
  transition: background-color 0.3s;

  :hover {
    background-color: ${({ theme }) => theme.colors.cyan};
  }

  > span {
    font-weight: 600;
    font-size: 16px;
  }
`;
